import { useTraduccion } from '@tallerya/i18n';
import { Ayuda } from '@tallerya/ui';
import { useTituloPantalla } from '../../layout/titulo';
import { EstadoApi } from '../../componentes/EstadoApi';

// La pantalla de entrada del sitio administrativo. Su resumen del día (Figma
// `12:373`) todavía no está: por ahora dice qué va a haber y que lo demás está
// en el menú.
//
// Se escribe así a propósito, en vez de con tarjetas y números de mentira. Una
// pantalla con datos inventados parece terminada y despista a quien la mira —
// incluido el propio equipo dentro de dos semanas.
export function Dashboard() {
  const { t } = useTraduccion();
  useTituloPantalla(t('admin.nav.inicio'));

  return (
    <>
      <div className="titulo-con-ayuda">
        <h1>{t('admin.inicio.titulo')}</h1>
        <Ayuda tema={t('admin.inicio.titulo')} texto={t('admin.inicio.entrada')} tono="titulo" />
      </div>

      <section className="aviso">
        <h2>{t('admin.inicio.aviso.titulo')}</h2>
        <p>{t('admin.inicio.aviso.texto')}</p>
      </section>

      {/* La comprobación del contrato de F-4. No es decoración: es el único
          lugar donde hoy se usan los tipos generados, y por eso es lo que hace
          que cambiar un DTO sin regenerar rompa la compilación. */}
      <EstadoApi />
    </>
  );
}
